<script setup lang="ts">
import {computed, watch} from 'vue';
import {useRoute} from 'vue-router';
import AppMenuItemLinha from './AppMenuItemLinha.vue';
import {useMenuPreferencias} from '@/layout/composables/useMenuPreferencias';
import {itemVisivel, moduloTemItemAtivo} from './menu.util';
import type {MenuModulo} from './menu.type';

const props = defineProps<{
    modulo: MenuModulo;
}>();

const route = useRoute();
const {estaAberto, alternarModulo, abrirModulo} = useMenuPreferencias();

const aberto = computed(() => estaAberto(props.modulo.id));
const temItemAtivo = computed(() => moduloTemItemAtivo(props.modulo, route));

const subgruposVisiveis = computed(() =>
    props.modulo.subgrupos
        .map((subgrupo) => ({
            titulo: subgrupo.titulo,
            itens: subgrupo.itens.filter(itemVisivel)
        }))
        .filter((subgrupo) => subgrupo.itens.length > 0)
);

watch(
    () => route.fullPath,
    () => {
        if (temItemAtivo.value) {
            abrirModulo(props.modulo.id);
        }
    },
    {immediate: true}
);

const aoClicarCabecalho = () => {
    alternarModulo(props.modulo.id);
};
</script>

<template>
    <div v-if="modulo.visible" class="menu-modulo" :class="{'menu-modulo--aberto': aberto, 'menu-modulo--ativo': temItemAtivo}">
        <button type="button" class="menu-modulo__cabecalho" :aria-expanded="aberto" :title="modulo.label" @click="aoClicarCabecalho">
            <i :class="modulo.icon" class="menu-modulo__icone"></i>
            <span class="menu-modulo__label">{{ modulo.label }}</span>
            <i class="pi pi-fw pi-angle-right menu-modulo__chevron"></i>
        </button>
        <div class="menu-modulo__corpo">
            <div class="menu-modulo__corpo-interno">
                <div v-for="(subgrupo, i) in subgruposVisiveis" :key="subgrupo.titulo ?? i" class="menu-subgrupo">
                    <div v-if="subgrupo.titulo" class="menu-subgrupo__titulo">{{ subgrupo.titulo }}</div>
                    <app-menu-item-linha v-for="item in subgrupo.itens" :key="item.id" :item="item"></app-menu-item-linha>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped></style>
